export default "__VITE_ASSET__27e9005d__"